<template>
  <!-- 头部 -->
  <div class="swiper_box">
    <div class="prev">
      <!-- <img :src="leftBtn" alt class="swiper-button" @click="clickPrev" /> -->
       <i class="el-icon-arrow-left"  @click="clickPrev"></i>
    </div>
    <div class="swiper_">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide class="item-device" v-for="(item, index) in list" :key="index">
          <div class="device">
            <div class="dev-img" @click="openDialog(item)">
              <!-- <img :src="item" alt /> -->
               <el-image
              style="width: 100px; height: 100px"
              :src="item" 
              :preview-src-list="list">
            </el-image>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div>

    </div>
    <!-- <el-dialog :visible.sync="dialogVisible" style="z-index:999">
         <img width="100%" :src="dialogImageUrl" alt />

      </el-dialog> -->
    <div class="next">
        <i class="el-icon-arrow-right"  @click="clickNext" ></i>
      <!-- <img :src="rightBtn" alt class="swiper-button" /> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "imgBoxDialog",
  props: {
      list:{
          type:Array,
      }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  data() {
    return {
      swiperOptions: {
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
        slidesPerView: "auto",
        freeMode: true,
        spaceBetween: 15,
        history: "love",
        // 设置点击箭头
        navigation: {
          nextEl: ".next",
          prevEl: ".prev",
        },
      },
      dialogVisible:false,
      dialogImageUrl:'',
      leftBtn: "", //左边点击按钮图片
      rightBtn: "", //右边点击按钮图片
      // deviceList: require("./device.json").deviceList, //这是轮播图图片数组
      deviceList: [
        { img: require("@/assets/image/aboutUs/1.png") },
        { img: require("@/assets/image/aboutUs/1.png") },
        { img: require("@/assets/image/aboutUs/1.png") },
        { img: require("@/assets/image/aboutUs/1.png") },
        { img: require("@/assets/image/aboutUs/1.png") },
        { img: require("@/assets/image/aboutUs/2.png") },
        { img: require("@/assets/image/aboutUs/3.png") },
        { img: require("@/assets/image/aboutUs/1.png") },
        { img: require("@/assets/image/aboutUs/1.png") },
        { img: require("@/assets/image/aboutUs/2.png") },
        { img: require("@/assets/image/aboutUs/3.png") },
        { img: require("@/assets/image/aboutUs/1.png") },
      ],
    };
  },
  methods: {
    /* 前一步 */
    clickPrev() {
      const that = this;
      const length = that.deviceList.length;
      if (that.activeBtn <= 0 || length == 0) {
        return false;
      }
    },
    /* 后一步 */
    clickNext() {
      const that = this;
      const length = that.deviceList.length;
      if (that.activeBtn >= length - 1 || length == 0) {
        return false;
      }
    },
    openDialog(url){
        this.dialogImageUrl = url
        this.dialogVisible = true
    },
  },
};
</script>
<style scoped lang="less">
.swiper_box {
  width: 100%;
  background: #fff;
  // padding: 36px 20px;
  padding-top:30px;
  box-sizing: border-box;
  // margin-top: 17px;
  background: rgba(0,0,0,0);
  display: flex;
  align-items: center;
  > div {
    display: inline-block;
    vertical-align: middle;
  }
  .swiper-button {
    width: 20px;
    height: 20px;
    cursor: pointer;
    text-align: center;
    padding: 0;
    font-weight: 500;
  }
  .swiper_ {
    width: calc(100% - 110px);
    margin: 0 30px;
    overflow: hidden;
    .item-device {
      width: 16em;
      .device {
        display: flex;
        flex-wrap: nowrap;
        .dev-img {
          width: 230px;
          height: 130px;
        //   background-color: #f00;
          padding: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  /deep/.el-dialog__wrapper{
      background: rgba(0,0,0,0.5);
  }
}
i{
    color:#2579BF;font-size:2.7em;
    font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/imgBoxAndDialog.vue